export default "__VITE_ASSET__CiSRtlqw__"